import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IStatus, StatusPicker } from '@dfl/mui-react-common';
import { useSecurity } from '@dfl/react-security';
import { KEYWORD_PERMISSIONS } from '../../constants';
import { KEYWORD_PRIORITY_STATUS, KEYWORD_PRIORITY_STATUS_MAP } from '../../constants/keyword-priority-status';
import { KEYWORD_PRIORITY_ENUM } from '../../interfaces';
import useUpdateKeywordPriority from '../../hooks/useUpdateKeywordPriority';

type KeywordPriorityPickerProps = {
  value: KEYWORD_PRIORITY_ENUM;
  keywordId: string;
  readOnly?: boolean;
};

const KeywordPriorityPicker = ({ value, keywordId, readOnly = false }: KeywordPriorityPickerProps) => {
  const { t } = useTranslation('keyword');
  const { hasPermission } = useSecurity();
  const { updateStatus: updateVisible, isLoading, value: lastValue } = useUpdateKeywordPriority(keywordId);

  const _value = useMemo(() => {
    return KEYWORD_PRIORITY_STATUS_MAP(t).get(lastValue ?? value) as IStatus;
  }, [lastValue, value, t]);

  return (
    <StatusPicker
      readOnly={readOnly || !hasPermission(KEYWORD_PERMISSIONS.KEYWORD_WRITE)}
      options={KEYWORD_PRIORITY_STATUS(t)}
      name='priority'
      size={'small'}
      isLoading={isLoading}
      value={_value}
      onChange={(status: IStatus) => updateVisible(status?._id)}
    />
  );
};

export default memo(KeywordPriorityPicker);
